<div
  class="card"
  *ngIf="prompts"
>
  <h3>Communication Prompts</h3>
  <div class="p-fluid">
    <div class="field">
      <label
        for="businessHours"
        class="block"
      >Business Hours</label>
      <textarea
        id="businessHours"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.businessHours"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="scheduleCommunicationsInstructions"
        class="block"
      >Schedule Communication: Instructions</label>
      <textarea
        id="scheduleCommunicationsInstructions"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.scheduleCommunicationsInstructions"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="scheduleCommunicationsRingGroups"
        class="block"
      >Schedule Communication: Ringgroups / Queues / Numbers</label>
      <textarea
        id="scheduleCommunicationsRingGroups"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.scheduleCommunicationsRingGroups"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="inboundCallRoutingNumbers"
        class="block"
      >Inbound Calls: Routing Numbers</label>
      <textarea
        id="inboundCallRoutingNumbers"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.inboundCallRoutingNumbers"
        [autoResize]="true"
      ></textarea>
    </div>
  </div>

  <p-button
    label="Update Prompts"
    (click)="updatePrompts()"
  ></p-button>
</div>